module.exports = require('./LegalHoldLabelView');
